module.exports = require('./LegalHoldLabelView');
